
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { Parametrizacao, ParametrizacaoService } from '@core/services/parametrizacao.service';
import { MessageService } from '@core/services/message.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NzButtonSize } from 'ng-zorro-antd/button';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { Sort } from '@angular/material/sort';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { ColumnOrder } from '@core/table/order';

@Component({
  selector: 'app-parametrizacao-list',
  templateUrl: './parametrizacao-list.component.html',
  styleUrls: ['./parametrizacao-list.component.scss']
})
export class ParametrizacaoListComponent implements OnInit {
  @ViewChild(NzTableComponent) table!: NzTableComponent<Parametrizacao>;

  size: NzButtonSize = 'large';
  parametrizacoes: Parametrizacao[] = [];
  nzFilterOption = (): boolean => true;

  dataSet: any[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;
  columOrder: ColumnOrder | undefined;

  constructor(
    private parametrizacaoService: ParametrizacaoService,
    private messageService: MessageService,
    private router: Router,
    public route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,

  ) { }

  ngAfterViewInit(): void {
    this.changeDetector.detectChanges();
    this.paginator.change.subscribe((val) => {
      this.pesquisar();
    })
    this.pesquisar();


  }

  ngOnInit() {
    this.pesquisar();
  }

  pesquisar(): void {
    this.parametrizacaoService.listarSort(
      null,
      this.paginator?.pagination,
      this.columOrder || {}
    ).subscribe((data) => {
      this.dataSet = data.content;
      this.paginator.totalItens = data.totalElements;
    });
  }

  sort(event: any) {
    const itemSelected = event.sort.find((x: any) => x.value);
    if (itemSelected) {
      this.columOrder = { sortField: itemSelected.key, sortOrder: itemSelected.value };
      this.pesquisar();
    }
  }

  loadData(sortParams?: any): void {
    // Método não é mais necessário, pois pesquisar centraliza tudo
  }

  // Novo item
  novo(obj: any) {
    this.router.navigate(['/parametrizacao/cadastrar'], { state: { titulo: obj.nome } });
  }

  editar(obj: any, id: number) {
    this.router.navigate(['/parametrizacao/editar', id], { state: { titulo: obj.nome } });
  }
}
